import { isExpressionString, isOfficialComponent } from "./validations.js";
export function getViewTitle(component) {
  var _component$children, _view$properties;
  var view = (_component$children = component.children) === null || _component$children === void 0 ? void 0 : _component$children.find(function (comp) {
    return isOfficialComponent(comp, "View");
  });
  var viewTitle = view === null || view === void 0 || (_view$properties = view.properties) === null || _view$properties === void 0 ? void 0 : _view$properties.title;
  if (typeof viewTitle === "string" && !isExpressionString(viewTitle)) {
    return viewTitle;
  }
}
//# sourceMappingURL=getViewTitle.js.map